import styles from 'styles/StudentNameScreen.module.css'
import Reveal from 'reveal.js'
import correctIcon from 'assets/images/common/check.svg'
import editIcon from 'assets/images/common/edit.svg'
import classNames from 'classnames'
import _ from 'lodash'
import { useEffect, useState } from 'react'

type StudentNameScreenPropsType = {
  greetingText: string;
  mascot?: string;
  studentNickNameRef: any;
  studentNickName: {nickName: {name: string; isFinal: boolean}};
}


function StudentNameScreen({ greetingText, mascot, studentNickName, studentNickNameRef}: StudentNameScreenPropsType) {

  const [buttonClicked, setButtonClicked] = useState(false);
  const [studentName, setStudentName] = useState('');

  useEffect(()=>{
    setStudentName(studentNickName.nickName.name);
  },[studentNickName.nickName.name])

  const updateStudentName = () => {
    let nickNameStudent = (document.getElementById('nickName') as HTMLInputElement).value;
    if(!nickNameStudent) {
      return
    }
    setStudentName(nickNameStudent);
    studentNickNameRef.update({nickName: { name: nickNameStudent, isFinal: true }})   
  }

  const onInputChange = () => {
    let nickNameStudent = (document.getElementById('nickName') as HTMLInputElement).value;
    setStudentName(nickNameStudent);
  }

  const allowEdit = () => {
    studentNickNameRef.update({nickName: {name: studentNickName.nickName.name, isFinal: false }})
  }

  const onClickStart = () => {
    setButtonClicked(true);
    if(studentNickName.nickName.name && studentNickName.nickName.isFinal){
      setButtonClicked(false);
      Reveal.next();
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        {greetingText}
      </div>
      {mascot && <img
        src={mascot}
        alt='mascot'
        className={styles.image}
      />}
      { (!studentNickName.nickName.isFinal) && 
        <div className={styles.inputContainer}>
          <input type='text' placeholder='Type Name Here..' id='nickName' onChange={onInputChange} defaultValue={studentNickName.nickName.name}/>
          <img
            src={correctIcon}
            alt='save'
            className={styles.icon}
            onClick={updateStudentName}
          />
        </div>
      }

      { (studentNickName.nickName.name && studentNickName.nickName.isFinal) &&
        <div className={styles.nameContainer}>
          <div className={styles.name}>
            { _.startCase(studentNickName.nickName.name) }
          </div>
          <img
            src={editIcon}
            alt='edit'
            className={styles.icon}
            onClick={allowEdit}
          />
        </div>
      }
      <div className={styles.buttonWrapper}>
        {(((!studentNickName.nickName.name || !studentNickName.nickName.isFinal) && buttonClicked) || (!studentName && buttonClicked)) 
        && <div className={styles.warningMsg}>
            Please enter and save your name to start.
        </div>}
        <div className={classNames(styles.button)} onClick={onClickStart}>
          START
        </div>
      </div>
      
    </div>
  )
}

export default StudentNameScreen
